import getCoords from "../../utilities/function/getCoords";
const Introduccion = (props) => {
  const { indice } = props;
  return (
    <div className="bg-amarillo lg:bg-transparent lg:fondo-introduccion lg:h-screen bg-repeat-x 2xl:bg-contain lg:relative py-5">


      <div className="contenido  pt-5 lg:pt-24">
        <img className="w-80 my-5 lg:hidden" src={require(`../../images/logo-fundacion-terpel.svg`).default} alt="logo terpel" />
      
        <div className="w-11/12 md:w-10/12 lg:w-7/12 mx-auto">
          <div className=" lg:h-80 xl:h-96 scroll-amarillo px-5">
            <h2 className="lato-900 text-40 mb-5">Sobre Diseña el Cambio</h2>
            <p className="lato-450 text-24 mb-5 text-negro-80">En la Fundación Terpel siempre hemos creído que “Cuanto más puedes soñar, más puedes hacer” porque <span className="font-bold">TODO ES POSIBLE</span>.  Con el programa Diseña el Cambio queremos empoderar y motivar a los niños, niñas y jóvenes a desarrollar ideas innovadoras que permitan impactar positivamente a sus comunidades y puedan transformar su entorno. Durante 17 años de existencia de la Fundación hemos trabajado por la educación de miles de estudiantes en las zonas más apartadas del país, implementando programas que incentivan el amor por la lectura, el interés por las matemáticas y además potencian el liderazgo.</p>

            <p className="lato-450 text-24 mb-5 text-negro-80">Con este propósito presente en nuestro quehacer, desde el año 2012 se han desarrollado más de 1.000 historias de cambio, involucrando a más de 500 mil estudiantes, para que juntos <span className="font-bold">HAGAMOS EL CAMBIO</span> y así, entre todos, construir un mejor futuro para las próximas generaciones. </p>

            <p className="lato-450 text-24 mb-5 text-negro-80">A continuación, encontrarás las más inspiradoras historias que contribuyen a la transformación del país que todos soñamos. Porque si <span className="font-bold">¡Yo puedo, Tú puedes!</span><br></br><br></br>Fundación Terpel, <br></br><br></br>Educamos para transformar vidas. </p>
          </div>
        </div>



      </div>

      <div className="lg:absolute bottom-0 center w-full mt-10 lg:h-40">
        <button
          className="text-24 text-negro mx-10  md:mx-auto  "
          onClick={() => {
            let topPosition = getCoords(indice.current).top;
            document.getElementsByTagName('html')[0].scrollTop = topPosition;
          }}
        >
          <p className="poppins-700">Te invitamos a leer las historias</p>
          <span className="icon-abajo"></span>
        </button>
      </div>

    </div>
  )
}

export default Introduccion;